import './App.css';
import Header from './components/Header';
import CosmicCard from './components/CosmicCard';
import FloatingOrb from './components/FloatingOrb';
import NeonTitle from './components/NeonTitle';
import Cursor from './components/Cursor';
import Planet from './components/Planet';

function App() {
  return (
    <div className='App'>
      <Cursor />      
      <section className="hero">
        <NeonTitle text="Spyridonas Flouris" />
        <p className="subtitle scroll">Full-Stack Developer • CSS Sorcerer</p>
        <FloatingOrb size={300} duration={30} color="cyan" position='left' />
        <FloatingOrb size={150} duration={18} color="magenta" position='center' />
      </section>

<section className="projects">
  <NeonTitle text="Featured Projects" />
  <a href="https://cytechsharp.com.cy" target="_blank" rel="noopener noreferrer">
    <CosmicCard delay={0.5} direction="down">
      My Website (Probably you came from there)
    </CosmicCard>
  </a>
  <a href="https://matcha-commerce.web.app/" target="_blank" rel="noopener noreferrer">
    <CosmicCard delay={0.1}>
      E-commerce Platform
    </CosmicCard>
  </a>
  <a href="/" rel="noopener noreferrer">
    <CosmicCard delay={0.3} direction="down">
      This Cosmic Page (you are here)
    </CosmicCard>
  </a>
</section>


      <section className="skills">
        <NeonTitle text="My Skills" Textcolor="--cosmic-white" />
        <Planet skills={['React', 'CSS', 'Node.js', 'Automation']} />
        <FloatingOrb size={200} duration={30} color="black" position="right" />
      </section>
      <br />
    </div>
  );
}

export default App;
